module.exports = __webpack_public_path__ + "img/access-facebook-ads.1c1b0726.png";